import style from "./lucky.module.css";
import Header from "../../components/header/Header";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import Placeholder from "../../components/placeHolder/PlaceHolder";
import { placeHolder } from "../../types/common";
import FooterCo from "../../components/footer/FooterCo";
const LuckyUser = () => {
  const dispatch = useAppDispatch();
  const { data, loading } = useAppSelector(
    (state) => state.luckuUsers.luckyUsers
  );
  const handleBack = function () {
    dispatch(configAction.setGameStep(GameStep.HOME));
  };

  const PercentUsers = function () {
    const percentUsr = data?.data.hundred_percent_winner_users;
    return (
      <div className={style.items}>
        {!loading ? (
          percentUsr?.map((item, index) => (
            <div className={style.item} key={index}>
              <div className={style.phone}>
                <span>{item.mobile}</span>
              </div>
              <div className={style.counter}>
                <span>{index + 1}</span>
              </div>
            </div>
          ))
        ) : (
          <Placeholder
            type={placeHolder.CONTENT}
            number={10}
            className={style.placeholder}
          />
        )}
      </div>
    );
  };
  return (
    <div className={style.lucky}>
      <div className={style.wrapper}>
        <Header title="لیست آخرین برندگان جوایز ویژه" onBack={handleBack} />
        <div className={style["winners-title"]}>
          <div
            style={{
              background: "#507687",
              borderRadius: 8,
              color: "#FCFAEE",
              fontSize: 14,
              fontWeight: 450,
              padding: "8px 24px",
              textAlign: "center",
            }}
          >
            <span>برندگان کد تخفیف %100</span>
          </div>
        </div>
        <div className={style.inner}>{<PercentUsers />}</div>
      </div>
      <FooterCo className="desktop" />
    </div>
  );
};

export default LuckyUser;
